define('uikit/extra/size',{
  MINI: 'mini',
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  BIG: 'big',
  HUGE: 'huge',
  MASSIVE: 'massive'
});

